import React from 'react';
import { Button } from 'components/ui';
import { FormattedMessage } from 'react-intl';
import { FilterAltIcon } from 'components/uiIcons';
import { ButtonSpan } from 'components/styles_components/span';

const FilterButton = ({ onClick, initPlaceFilterValues, placesFilter, size = 'medium' }) => {
  return (
    <Button
      size={size}
      onClick={onClick}
      endIcon={<FilterAltIcon />}
      variant="outlined"
      color={
        JSON.stringify(initPlaceFilterValues) === JSON.stringify(placesFilter)
          ? 'primary'
          : 'warning'
      }
    >
      <ButtonSpan>
        <FormattedMessage id="button.filter" />
      </ButtonSpan>
    </Button>
  );
};

export default FilterButton;
